module.exports = "<ul>\n  <li ng-repeat=\"job in vm.familyJobs | filter: { level: vm.level } | orderBy: '-match' | limitTo: 2 track by job.id\">\n    <span ng-bind=\"job.match + '%'\"></span>\n    <a ng-href=\"{{job.url}}\" ng-bind=\"::job.name\"></a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/bestJobs/bestJobs.html
// module id = 134
// module chunks = 0 1